import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import monthly from "../../images/monthly.png";
import number from "../../images/number.png";
import CommonTitle from "../../components/common-title";
import {getRecruitsVisibleLists} from "../../service";
import {RecruitsVisibleData} from '../types'
import usePagination from "../../routers/usePagination";
import Pagination from "../../components/pagination";
import {nounTsf} from "../../units";


function Opportunity() {

    const [lists,setLists] = useState<Array<RecruitsVisibleData>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination();

    useEffect(() =>{
        getRecruitsVisibleLists({
            pageNum
        }).then(res => {
            if(res.code === 1){
                const lists = res.data.list
                if((lists as Array<RecruitsVisibleData>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            }else{
                noMore()
            }
        })
    },[pageNum])

    return <div className="jobs">
        <CommonTitle title={"工作机会"}/>
        <div className="opportunity-box">
            {
                lists.map((item,index) => {
                    return <Link to={`/job/opportunity/${ item.id }/detail`} key={index}>
                        <div className="opportunity-item">
                            <div className="img" style={{backgroundImage: `url(${item.coverUrl})`}}/>
                            <div className="text">
                                <p className="title">{ item.recruitTitle } </p>
                                <div className="monthly">
                                    <img src={monthly} alt=""/>
                                    <p>月薪：{ item.salary }</p>
                                </div>
                                <div className="number">
                                    <img src={number} alt=""/>
                                    <p>编号：{ item.recruitNumber }</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                })
            }
        </div>
        <Pagination ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>

    </div>
}

export default Opportunity
